// removed by extract-text-webpack-plugin
module.exports = {"DrawerToggle":"DrawerToggle__DrawerToggle__1eThf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/DrawerToggle/DrawerToggle.css
// module id = 38
// module chunks = 0